module.exports = __webpack_public_path__ + "static/media/ColourSans-Regular.c1fb05ba.woff2";